import React from 'react';

function JobApply() {
    return (
        <div className="job-listing-page pd-top-190">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-lg-10">
                        <div className="section-title text-center">
                            <h2 className="title">Apply Now</h2>
                            <p>Please upload your resume and fill in the fields below to apply for your desired position.</p>
                        </div>
                        <div className="job-apply-area">
                            <form className="FusionHub-form-wrap">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="single-input-wrap">
                                            <input type="text" className="single-input" required />
                                            <label>First Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="single-input-wrap">
                                            <input type="email" className="single-input" required />
                                            <label>E-mail</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="single-input-wrap">
                                            <input type="text" className="single-input" required />
                                            <label>Phone</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="single-input-wrap">
                                            <input type="text" className="single-input" required />
                                            <label>Applying for the position of</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="single-input-wrap">
                                            <textarea className="single-input" cols="20" />
                                            <label>Portfolio Link</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="single-input-wrap">
                                            <textarea className="single-input" cols="20" required />
                                            <label>Write Your Message</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="custom-file FusionHub-file-input-wrap">
                                            <input type="file" className="FusionHub-file-input" id="sb-file-input" />
                                            <label className="custom-file-label bg-dark rounded" htmlFor="sb-file-input">Upload Your Resume</label>
                                        </div>
                                    </div>
                                    <div className="col-12 text-center">
                                        <button className="btn btn-blue text-dark" href="#">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JobApply;
